<template>
  <div class="status-change-dropout-not-audit-final-pass">
    <el-form-item label="退学原因">
      <el-select v-model="form.reasonCode">
        <template v-if="selectInfo && selectInfo.reasons">
          <el-option v-for="reason in selectInfo.reasons"
                     :key="reason.code"
                     :label="reason.name"
                     :value="reason.code"></el-option>
        </template>
      </el-select>
    </el-form-item>
    <el-form-item v-if="isCustomReason"
                  label="退学原因详情">
      <el-input v-model="form.reasonNote"
                type="textarea"
                maxlength="100"></el-input>
    </el-form-item>
    <el-form-item label="需退还学费">
      <div class="input-group">
        <el-input-number v-model="form.dropoutFee"
                         controls-position="right"
                         :min="0"
                         :precision="2"
                         :step="1"></el-input-number>
        <span class="unit">元</span>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import objectUtils from '../../../../../../../../../../util/objectUtils'
export default {
  name: 'StatusChangeDropoutNotAuditFinalPass',
  props: {
    applyId: {
      type: String,
      required: true
    },
    auditInfo: {
      type: Object,
      required: true
    },
    selectInfo: Object
  },
  data () {
    return {
      form: {
        reasonCode: '',
        reasonNote: '',
        dropoutFee: undefined
      }
    }
  },
  computed: {
    isCustomReason () {
      const reasonCode = this.form.reasonCode
      if (reasonCode) {
        const selectInfo = this.selectInfo
        if (selectInfo) {
          const reasons = selectInfo.reasons
          if (reasons) {
            let getReason = reasons.find(reason => reason.code === this.form.reasonCode)
            if (getReason) {
              return getReason.custom
            }
          }
        }
      }
    }
  },
  methods: {
    getAuditInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.reasonCode) {
          reject(new Error('请选择退学原因'))
          return
        }
        if (this.isCustomReason) {
          if (!this.form.reasonNote) {
            reject(new Error('请填写退学原因详情'))
            return
          }
        }
        if (!objectUtils.hasValue(this.form.dropoutFee)) {
          reject(new Error('请填写需退还学费'))
          return
        }
        resolve(this.resolveAudit(this.form))
      })
    },
    resolveAudit (form) {
      return {
        url: '/workspace/manager/status/change/auditDropout/final/submitPassed',
        data: this.$qs.stringify(this.$extend({
          postId: this.applyId
        }, form))
      }
    }
  },
  watch: {
    auditInfo: {
      handler (val) {
        if (val) {
          Object.keys(this.form).forEach(key => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = val[key] || ''
            } else {
              this.form[key] = val[key]
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>
